// extracted by mini-css-extract-plugin
export var actions = "_tm-4";
export var item = "_tm-1";
export var price = "_tm-3";
export var quantity = "_tm-2";
export var table = "_tm-0";